import { PagesTableRow } from './pages-table-row';

export { PagesTableRow };
